import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, {useState} from 'react';

import {DynamicPriceText} from '@udemy/browse-course';
import {PURCHASE_PRICE_TYPES, ShoppingClient} from '@udemy/shopping';
import {useUDData} from '@udemy/ud-data';

import {isCountryTaxExclusive} from 'src/features/checkout/helpers/checkout-client';

import {FullCreditTotalPrice} from '../full-credit-total-price/full-credit-total-price.react-component';
import styles from './total-price.module.less';

interface TotalPriceProps {
    listName: keyof typeof ShoppingClient.lists;
    canShowCredit?: boolean;
}

export const TotalPrice: React.FC<TotalPriceProps> = observer(
    ({canShowCredit = false, listName}) => {
        const {Config} = useUDData();
        const [list] = useState(ShoppingClient.lists[listName]);

        const credit = ShoppingClient.credit.amount;

        const getTotalDue = () => {
            return Math.max(list.purchasePriceAmount - credit, 0);
        };

        const isSubtotalLabel = () => {
            return isCountryTaxExclusive(Config.price_country?.id);
        };

        if (!list.items.length || !list.listPriceAmount) {
            return null;
        }

        if (canShowCredit && credit) {
            return (
                <FullCreditTotalPrice
                    list={list}
                    chargePrice={getTotalDue()}
                    credit={credit}
                    isSubtotalLabel={isSubtotalLabel()}
                />
            );
        }

        return (
            <div className={classNames(styles['total-checkout-container'])}>
                <DynamicPriceText
                    className={styles['checkout-price-text']}
                    showTotalLabel={true}
                    isSubtotalLabel={isSubtotalLabel()}
                    totalLabelClassName={classNames(styles['total-label'], 'ud-heading-md')}
                    discountPrice={getTotalDue()}
                    discountPriceClassName={classNames('ud-heading-xxl')}
                    percentDiscount={list.discountPercentage}
                    showPercentDiscount={true}
                    percentDiscountClassName={'ud-text-md'}
                    listPrice={list.listPriceAmount}
                    listPriceClassName={'ud-text-md'}
                    trackingEventContext={{
                        priceType: PURCHASE_PRICE_TYPES.total,
                    }}
                />
            </div>
        );
    },
);
